<template>
  <a-form ref="advertisementForm" :model="form" layout="vertical">
    <a-divider orientation="left">
      Brand
    </a-divider>
    <a-row :gutter="20">
      <a-col :span="12">
        <a-form-item label="Name">
          <a-input v-model:value="form.name" placeholder="Name" />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item label="Logo">
          <a-input v-model:value="form.logo" placeholder="Url" />
        </a-form-item>
      </a-col>
    </a-row>

    <a-divider orientation="left">
      Ad
    </a-divider>

    <div class="grid grid-cols-3 gap-10">
      <div>
        <a-form-item label="Collections">
          <a-select
            mode="multiple"
            placeholder="Select a collection"
            option-filter-prop="children"
            v-model:value="form.collections"
          >
            <a-select-option
              :value="item.id"
              v-for="item in collections"
              :key="item.id"
            >
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>
    </div>

    <div class="grid grid-cols-3 gap-10">
      <div>
        <a-form-item label="Visible">
          <Switch v-model="form.visible" />
        </a-form-item>
      </div>
      <!-- <div>
        <a-form-item label="New">
          <Switch v-model="form.new" />
        </a-form-item>
      </div> -->
      <div>
        <a-form-item label="Placement">
          <a-checkbox @change="onPlacement">
            Instagram Stories
          </a-checkbox>
        </a-form-item>
      </div>
    </div>

    <a-row :gutter="20">
      <a-col :span="8">
        <a-form-item label="Media Type">
          <a-radio-group
            v-model="media_type"
            @change="handleMediaType"
            button-style="solid"
          >
            <a-radio-button value="drive">
              Drive
            </a-radio-button>
            <a-radio-button value="file">
              File
            </a-radio-button>
            <a-radio-button value="link">
              Link
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
      <a-col :span="16">
        <a-form-item label="Media">
          <input
            type="file"
            @change="onFileChanged"
            v-if="media_type == 'file'"
          />
          <a-input
            v-model:value="form.media_source"
            placeholder="Name"
            v-if="media_type !== 'file'"
          />
        </a-form-item>
      </a-col>
    </a-row>

    <a-form-item label="Primary text">
      <a-textarea
        v-model:value="form.primary_text"
        placeholder="Primary text"
        :rows="4"
      />
    </a-form-item>

    <a-form-item label="Headline">
      <a-textarea
        v-model:value="form.headline"
        placeholder="Headline"
        :rows="4"
      />
    </a-form-item>

    <a-form-item label="Description">
      <a-textarea
        v-model:value="form.description"
        placeholder="Description"
        :rows="4"
      />
    </a-form-item>

    <div class="grid grid-cols-5 gap-4">
      <div class="col-span-3">
        <a-form-item label="Display Link">
          <a-input
            v-model:value="form.display_link"
            placeholder="Display Link"
          />
        </a-form-item>
      </div>

      <div class="col-span-2">
        <a-form-item label="Call to Action">
          <a-select
            v-model:value="form.call_to_action"
            placeholder="Call to Action"
          >
            <a-select-option
              v-for="action in actionsTexts"
              :value="action"
              :key="action"
            >
              {{ action }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>
    </div>

    <a-divider orientation="left">
      Analysis
    </a-divider>
    <a-form-item label="Analysis">
      <a-textarea
        v-model:value="form.analysis"
        placeholder="Analysis"
        :rows="4"
      />
    </a-form-item>
    <a-form-item label="Tags">
      <a-select v-model:value="form.tags" mode="tags" placeholder="Tags">
      </a-select>
    </a-form-item>
    <a-row :gutter="20">
      <a-col :span="12">
        <a-form-item label="Industry">
          <div class="custom_select--group">
            <CustomSelect
              v-model="form.industry"
              :options="industries"
              @onchange="handleIndustry"
            />
            <a-form-item v-if="subindustries" label="Subindustry">
              <CustomSelect
                v-model="form.subindustry"
                :options="subindustries"
              />
            </a-form-item>
          </div>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item label="Type">
          <div class="custom_select--group">
            <CustomSelect
              v-model="form.type"
              :options="types"
              :multiple="true"
            />
            <a-form-item
              label="Seasonal"
              v-if="form.type && form.type.includes('Seasonal')"
            >
              <CustomSelect v-model="form.seasonal" :options="seasonal" />
            </a-form-item>
          </div>
        </a-form-item>
      </a-col>
    </a-row>
    <div class="grid grid-cols-12 gap-8">
      <div class="col-span-4">
        <a-form-item label="Format">
          <CustomSelect
            v-model="form.format"
            :options="['Video', 'Static Image']"
          />
        </a-form-item>
      </div>
      <div class="col-span-4">
        <a-form-item label="Video Type">
          <CustomSelect
            v-model="form.video_type"
            :options="['Post-Production only', 'Filmed Video needed']"
          />
        </a-form-item>
      </div>
      <div class="col-span-4">
        <a-form-item label="Video Length">
          <CustomSelect
            v-model="form.video_length"
            :options="['More than 20 sec', 'Less than 20 sec']"
          />
        </a-form-item>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-8">
      <div class="col-span-4">
        <a-form-item label="Gender">
          <CustomSelect
            v-model="form.gender"
            multiple
            :options="['Female', 'Male']"
          />
        </a-form-item>
      </div>
      <div class="col-span-4">
        <a-form-item label="Objective">
          <CustomSelect
            v-model="form.objective"
            multiple
            :options="objectives"
          />
        </a-form-item>
      </div>
    </div>
  </a-form>
</template>

<script>
import CustomSelect from "@/components/CustomSelect";
import Switch from "@/components/UI/Switch.vue";

export default {
  components: { CustomSelect, Switch },
  props: {
    modelValue: Object,
    mediaType: String,
  },
  mounted() {
    this.$store.dispatch("GET_COLLECTIONS");
  },
  data() {
    return {
      isLoading: false,
      subindustries: null,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
    };
  },
  computed: {
    media_type: {
      get() {
        return this.mediaType;
      },
      set(newValue) {
        this.$emit("update:mediaType", newValue);
      },
    },
    form: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit("update:modelValue", newValue);
      },
    },
    collections() {
      return this.$store.state.collections;
    },
    actionsTexts() {
      return this.$store.state.actionsTexts;
    },
    industries() {
      return this.$store.state.industries;
    },
    types() {
      return this.$store.state.types;
    },
    seasonal() {
      return this.$store.state.seasonal;
    },
    objectives() {
      return this.$store.state.objectives;
    },
  },
  methods: {
    handleMediaType(value) {
      this.media_type = value.target.value;
    },
    onFileChanged(event) {
      this.form.media_source = event.target.files[0];
    },
    handleIndustry(value) {
      this.form.industry = value;
      this.form.subindustry = null;
      const industry = this.industries.find((item) => item.value === value[0]);
      if (industry.values) {
        this.subindustries = industry.values;
      } else {
        this.subindustries = null;
      }
    },
    onPlacement(value) {
      this.form.placement = value.target.checked;
    },
  },
};
</script>

<style></style>
